import React from 'react';
import { t } from '../utils/translations';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  text?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '', 
  text = t('common.loading'),
  fullScreen = false
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6 sm:h-8 sm:w-8',
    lg: 'h-8 w-8 sm:h-12 sm:w-12',
    xl: 'h-12 w-12 sm:h-16 sm:w-16'
  };

  const textSizeClasses = {
    sm: 'text-xs sm:text-sm',
    md: 'text-sm sm:text-base',
    lg: 'text-base sm:text-lg',
    xl: 'text-lg sm:text-xl'
  };

  const containerClasses = fullScreen 
    ? 'flex flex-col items-center justify-center min-h-screen-safe safe-area-padding' 
    : 'flex flex-col items-center justify-center';

  return (
    <div className={`${containerClasses} space-y-3 sm:space-y-2 ${className}`}>
      <div className={`animate-spin rounded-full border-2 border-gray-300 dark:border-gray-600 border-t-primary-600 dark:border-t-primary-400 ${sizeClasses[size]}`}></div>
      {text && (
        <p className={`text-gray-600 dark:text-gray-300 font-medium ${textSizeClasses[size]} text-center px-4`}>
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
